export const zIndices = {
  tableFilter: 9,
  drawer: 400,
  overlay: 700,
  modal: 500,
  toaster: 2000,
  tooltip: 800,
} as const;

export type ZIndices = typeof zIndices;
